export default __webpack_public_path__ + "static/media/06-Akash-Kapadia.61f85870.png";